export default __webpack_public_path__ + "static/media/bnaya-barbi_achshav_halev_patuach.129ec68d.mp3";